import React, { useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { PlusCircle, GearSix } from '@phosphor-icons/react';

import ClientContext from 'app/src/contexts/ClientContext';
import { ICON_SIZES } from 'app/src/elements/Icon';
import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import { Link } from 'app/src/utils/routing';

export const Container = styled(View)`
  background-color: ${colors.header};
  padding: 20px 24px;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  z-index: 9999;
`;

export const SiteTitle = styled(Text)`
  color: ${colors.textOnDark};
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-right: 16px;
`;

const Label = styled(Text)`
  color: ${colors.textOnDark};
  font-size: 16px;
`;

const NavLink = styled(Text)`
  color: ${colors.textOnDark};
  font-size: 16px;
`;

const Settings = styled(View)`
  position: absolute;
  right: -20px;
  top: 40px;
  background-color: ${colors.headerAlt};
  padding: 16px 20px;
  width: 180px;
  gap: 16px;
  border-radius: 4px;
  border-width: 1px;
  border-color: ${colors.textLight};
`;

const SettingsLabel = styled(Text)`
  color: ${colors.textOnDark};
  font-size: 14px;
`;

const SETTINGS_ITEMS = [
  {
    path: '/clients',
    label: 'Clients',
  },
  {
    path: '/event-types',
    label: 'Event Types',
  },
  {
    path: '/things',
    label: 'Things',
  },
  {
    path: '/medicines',
    label: 'Medicines',
  },
  {
    path: '/medicine-groups',
    label: 'Medicine Groups',
  },
  {
    path: '/providers',
    label: 'Providers',
  },
  {
    path: '/users',
    label: 'Users',
  },
  {
    path: '/account/profile',
    label: 'Profile',
  },
];

const Menu = () => {
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const { logout } = useContext(ClientContext);

  return (
    <Container>
      <Link to="/">
        <SiteTitle>
          Keeping.Care
        </SiteTitle>
      </Link>

      <Link to="/events">
        <NavLink>Events</NavLink>
      </Link>

      <Link to="/events/new">
        <PlusCircle
          size={ICON_SIZES.button}
          weight="regular"
          color={colors.textOnDark}
          aria-label="Add new event"
        />
      </Link>

      <Link to="/things/choose">
        <Label>Choice</Label>
      </Link>

      <Pressable
        onPress={() => setShowSettingsMenu(!showSettingsMenu)}
        style={{ marginLeft: 'auto' }}
        accessibilityLabel="Settings menu"
      >
        <GearSix
          size={ICON_SIZES.button}
          weight="regular"
          color={colors.textOnDark}
          aria-label="Settings"
        />

        {showSettingsMenu && (
          <Settings>
            {SETTINGS_ITEMS.map(({ path, label }) => (
              <Link key={label} to={path}>
                <SettingsLabel>{label}</SettingsLabel>
              </Link>
            ))}

            <Pressable onPress={logout}>
              <SettingsLabel>Logout</SettingsLabel>
            </Pressable>
          </Settings>
        )}
      </Pressable>
    </Container>
  );
};

export default Menu;
